<div class="editor-container">
  <!-- Readonly (no toolbar) -->
  <dx-html-editor *ngIf="isReadonly" [(value)]="content" [readOnly]="true" [height]="'80vh'">
  </dx-html-editor>

  <!-- Editable (with toolbar) -->
  <dx-html-editor *ngIf="!isReadonly" [(value)]="content" [readOnly]="false" [toolbar]="toolbar" [height]="'80vh'">
  </dx-html-editor>

  <div class="actions">
    <dx-button text="Sačuvaj" type="default" (onClick)="save()" [visible]="!isReadonly">
    </dx-button>

    <!-- <dx-button
      text="Očisti"
      type="normal"
      (onClick)="clear()"
      [visible]="!isReadonly">
    </dx-button> -->
  </div>
</div>